module.exports = __webpack_public_path__ + "img/Gayle Lewis.d4198f85.png";